import { openOfflineDb } from './db';
import { inspectStorageSafety } from './storageSafety';
import { startConnectivityEngine } from './connectivity';
import { startSyncCoordinator } from './syncCoordinator';
import { initializePwaUpdateCoordinator } from './pwaUpdate';
import { collectClientHealth, reportClientHealth } from './health';
import { checkServerCompatibility } from './compatibility';
import { registerFieldAgentOfflineHandlers } from '../services/offlineFieldAgent';

let initialized = false;
let cleanup: Array<() => void> = [];

export async function initializeOfflineKernel(): Promise<void> {
  if (initialized) return;
  initialized = true;
  try {
    await openOfflineDb();
    await inspectStorageSafety(true);
  } catch (error) {
    console.error('[offline-kernel] local database/storage initialization failed', error);
    localStorage.setItem('coconnect_last_offline_error', 'OFFLINE_DB_INITIALIZATION_FAILED');
  }
  registerFieldAgentOfflineHandlers();
  cleanup.push(startConnectivityEngine());
  cleanup.push(await startSyncCoordinator());
  cleanup.push(initializePwaUpdateCoordinator());
  void collectClientHealth().catch(() => {});
  void checkServerCompatibility().catch(() => {});
  const healthTimer = window.setInterval(() => { void reportClientHealth().catch(() => {}); }, 5 * 60 * 1000);
  cleanup.push(() => window.clearInterval(healthTimer));
}

export function stopOfflineKernel(): void {
  cleanup.splice(0).forEach(fn => { try { fn(); } catch {} });
  initialized = false;
}

export * from './types';
export * from './featureMatrix';
export * from './db';
export * from './commandBus';
export * from './syncCoordinator';
export * from './connectivity';
export * from './storageSafety';
export * from './authEnvelope';
export * from './criticalSessions';
export * from './health';
export * from './capabilities';
export * from './referenceData';
export * from './workflows';
export * from './compatibility';
export * from './diagnostics';
export * from './maintenance';
